<template>
  <div class="animated fadeIn">
      <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
        <strong> Regularization </strong> 
        </div>
       
      <div class="mb-3">
        <b-row class="p-2">

<b-col md="6">
  <b-form-group>
    <b-form-group label="Select Hub"
                                      :label-cols="4">
                                          <b-form-select  v-model="valueWH" @change="onChangeHubID($event,'selecthub')">
                                              <option :value="null">-- Select Hub --</option>
                                              <option :value="hub.id" v-for="hub in optionsWH"  :key="hub.id" >
                                                {{hub.name}}
                                              </option>
                                              
                                          </b-form-select>
                                      </b-form-group>


  </b-form-group>
</b-col>

<b-col md="6">
  <b-form-group>
    <b-form-group label="Select Employee Name"
                                      :label-cols="4">
                                          <b-form-select  v-model="valueEmpName" @change="onChangeEmpName($event,'emp_name')">
                                              <option :value="null">-- Select Employee Name --</option>
                                              <option :value="emp.name" v-for="emp in employeelist"  :key="emp.name" >
                                                {{emp.name}}
                                              </option>
                                              
                                          </b-form-select>
                                      </b-form-group>


  </b-form-group>
</b-col>
</b-row>
<b-row class="p-2">
<b-col md="6">
  <b-form-group>
    <b-form-group label="Employee ID :"
                                      :label-cols="4">
                                      <b-form-select v-model="empId" @change="onChangeEmPID($event,'emp_id')" disabled>
  <option :value="null">-- Employee ID : --</option>
  <option 
    v-for="(emp, index) in employeeIDList"  
    :key="index"
    :value="emp"
  >
    {{ emp }}
  </option>
</b-form-select>

                                      </b-form-group>


  </b-form-group>
</b-col>

<b-col md="6">
  <b-form-group>
    <b-form-group label="Employee Mobile No. :"
                                      :label-cols="4">
                                          <b-form-select  v-model="value_mobile_no" @change="onChangeEmpMobile($event, 'emp_mob_no')" disabled>
                                              <option :value="null">-- Employee Mobile No. : --</option>
                                              <option :value="emp" v-for="emp in employeeMobileList"  :key="emp.userid" >
                                                {{emp}}
                                              </option>
                                              
                                          </b-form-select>
                                      </b-form-group>


  </b-form-group>
</b-col>

</b-row>

          <b-row>
              <b-col sm="12" class="text-right">
                  <p > <b>Total Records :<span style="color:red;" v-if="tableEmpList && tableEmpList.length > 0">{{tableEmpList.length}}</span></b> </p>
               </b-col>
          </b-row>
          <div>
              <b-table
              show-empty responsive :fields="fields" :items="tableEmpList" :filter="filter" :busy="loadisBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :bordered="bordered" fixed-header
              >
                  <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                  </div>                   

              <template slot="action" slot-scope="row">
                          <b-button
                          size="sm"
                          @click="openEmpDetails(row)"
                          data-toggle="tooltip"
                          title="Approve"
                          class="mr-1 custom-approve-btn"
                          variant="success"
                          :disabled="row.item.approve_reject_action === 1"
                          >
                          Approve
                          </b-button>
                          <b-button
                          size="sm"
                          @click="openEmpDetails(row)"
                          data-toggle="tooltip"
                          title="Reject"
                          class="mr-1 custom-reject-btn"
                          variant="danger"
                          :disabled="row.item.approve_reject_action === 1"
                          >
                          Reject
                          </b-button>&nbsp;
                      </template>

                 
              

                  
              </b-table>
             
          </div>


      </div>
<div v-if="valueWH && valueEmpName">
    <!-- Selected Date -->
    <b-row>
<!-- Selected Date -->
<b-col md="12" class="mb-3">
  <b-form-group>
    <b-row class="align-items-center">
      <b-col md="4" class="text-md-end">
        <label class="mb-0"><strong>Selected Date:</strong></label>
      </b-col>
      <b-col md="4">
        <v-date-picker
          mode="single"
          input-class="dateInput"
          :available-dates="availableDates"
          v-model="selectDateForRegularize"
        />
      </b-col>
    </b-row>
  </b-form-group>
</b-col>

<!-- Week Off -->
<b-col md="12" class="mb-1">
  <b-form-group>
    <b-row class="align-items-center">
      <b-col md="4" class="text-md-end">
        <label class="mb-0"><strong>Week Off:</strong></label>
      </b-col>
      <b-col md="4">
        <b-form-radio-group v-model="selected_weekOff">
          <b-form-radio value="yes">Yes</b-form-radio>
          <b-form-radio value="no">No</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
  </b-form-group>
</b-col>
<b-row class="p-4" v-if="selected_weekOff == 'no'">

<b-col md="12" class="mb-3">
  <b-form-group>
    <b-row class="align-items-center">
      <b-col md="4" class="text-md-end">
        <label class="mb-0"><strong>Select Shift:</strong></label>
      </b-col>
      <b-col md="4">
        <v-select
          v-model="selectedShift"
          :options="ShiftOptions"
          placeholder="-- Select Reason --"
        ></v-select>
      </b-col>
    </b-row>
  </b-form-group>
</b-col>



<!-- Actual Shift Timings -->
<b-col md="12" class="mb-3">
  <b-form-group label="Actual Shift Timings:">
    <b-row class="align-items-center mb-2">
      <b-col md="4" class="text-md-end">
        <label class="mb-0">From:</label>
      </b-col>
      <b-col md="4" class="d-flex align-items-center">
        <b-form-select
          v-model="form.effectiveStartHour"
          :options="[{ value: '', text: 'HH', disabled: true }, ...(startHourOptions || [])]"
          required
          class="time-select me-1"
        />
        <span class="me-1">:</span>
        <b-form-select
          v-model="form.effectiveStartMinute"
          :options="[{ value: '', text: 'MM', disabled: true }, ...minuteOptions]"
          required
          class="time-select"
        />
      </b-col>
    </b-row>

    <b-row class="align-items-center">
      <b-col md="4" class="text-md-end">
        <label class="mb-0">To:</label>
      </b-col>
      <b-col md="4" class="d-flex align-items-center">
        <b-form-select
          v-model="form.effectiveEndHour"
          :options="[{ value: '', text: 'HH', disabled: true }, ...(endHourOptions || [])]"
          required
          class="time-select me-1"
        />
        <span class="me-1">:</span>
        <b-form-select
          v-model="form.effectiveEndMinute"
          :options="[{ value: '', text: 'MM', disabled: true }, ...minuteOptions]"
          required
          class="time-select"
        />
      </b-col>
    </b-row>
  </b-form-group>
</b-col>




<b-col md="12" class="mb-3">
  <b-form-group>
    <b-row class="align-items-center mb-2">
      <b-col md="4" class="text-md-end">
        <label class="mb-0"><strong>Total Break Duration:</strong></label>
      </b-col>
      <b-col md="4" class="d-flex align-items-center">
        <b-form-select
          v-model="form.break_effectiveStartHour"
          :options="[{ value: '', text: 'HH', disabled: true }, ...hourOptions]"
          required
          class="time-select me-1"
        />
        <span class="me-1">:</span>
        <b-form-select
          v-model="form.break_effectiveEndMinute"
          :options="[{ value: '', text: 'MM', disabled: true }, ...minuteOptions]"
          required
          class="time-select"
        />
      </b-col>
    </b-row>

   
  </b-form-group>
</b-col>

<b-col md="12" class="mb-3">
  <b-form-group>
    <b-row class="align-items-center">
      <b-col md="4" class="text-md-end">
        <label class="mb-0"><strong>Did You Do OverTime:</strong></label>
      </b-col>
      <b-col md="4">
        <b-form-radio-group v-model="selected_overTime">
          <b-form-radio value="overtime-yes">Yes</b-form-radio>
          <b-form-radio value="overtime-no">No</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
  </b-form-group>
</b-col>


<b-col md="12" class="mb-3" v-if="selected_overTime == 'overtime-yes'">
  <b-form-group label="Actual OverTime Timings:">
    <b-row class="align-items-center mb-2">
      <b-col md="4" class="text-md-end">
        <label class="mb-0">From:</label>
      </b-col>
      <b-col md="4" class="d-flex align-items-center">
        <b-form-select
          v-model="form.ovetime_effectiveStartHour"
          :options="[{ value: '', text: 'HH', disabled: true }, ...filteredOvertimeEndHours]"
          required
          class="time-select me-1"
        />
        <span class="me-1">:</span>
        <b-form-select
          v-model="form.ovetime_effectiveStartMinute"
          :options="[{ value: '', text: 'MM', disabled: true }, ...filteredOvertimeEndMinutes]"
          required
          class="time-select"
        />
      </b-col>
    </b-row>

    <b-row class="align-items-center">
      <b-col md="4" class="text-md-end">
        <label class="mb-0">To:</label>
      </b-col>
      <b-col md="4" class="d-flex align-items-center">
        <b-form-select
          v-model="form.ovetime_effectiveEndHour"
          :options="[{ value: '', text: 'HH', disabled: true }, ...filteredOvertimeEndHours]"
          required
          class="time-select me-1"
        />
        <span class="me-1">:</span>
        <b-form-select
          v-model="form.ovetime_effectiveEndMinute"
          :options="[{ value: '', text: 'MM', disabled: true }, ...filteredOvertimeEndMinutes]"
          required
          class="time-select"
        />
      </b-col>
    </b-row>
  </b-form-group>
</b-col>

</b-row>


<!-- Select Reason -->
<b-col md="12" class="mb-3">
  <b-form-group>
    <b-row class="align-items-center">
      <b-col md="4" class="text-md-end">
        <label class="mb-0"><strong>Select Reason:</strong></label>
      </b-col>
      <b-col md="4">
        <v-select
          v-model="selectedReason"
          :options="filteredReasonOptions"
          placeholder="-- Select Reason --"
          :disabled="selected_weekOff === 'yes'"
        ></v-select>
      </b-col>
    </b-row>
  </b-form-group>
</b-col>

<!-- Comment -->
<b-col md="12" class="mb-3">
  <b-form-group>
    <b-row class="align-items-start">
      <b-col md="4" class="text-md-end">
        <label for="fc_comment" class="mb-0"><strong>Comment:</strong></label>
      </b-col>
      <b-col md="4">
        <b-form-textarea
          id="fc_comment"
          v-model="fc_comment"
          placeholder="---type---"
          rows="3"
        />
      </b-col>
    </b-row>
  </b-form-group>
</b-col>

<b-col md="12" class="mb-3">
<b-form-group>
  <b-row class="align-items-center">
    <!-- Label -->
    <b-col md="4" class="text-md-end">
      <label class="mb-0">
        <strong>Choose File:</strong>
      </label>
    </b-col>

    <!-- File Upload -->
    <b-col md="4">
      <b-form-group>
                                              <b-form-file
                                                type="file"
                                                v-model="image_file"
                                                :state="Boolean(image_file)"
                                                placeholder="Upload Photo" 
                                                @change="selectFile($event)"
                                                accept="image/*"
                                                class="custom-border"
                                               >
                                               <template v-slot:file-name>
                                                  {{ fileUploadMessage }}
                                              </template>
                                                </b-form-file>
                                              
                                             
                                          </b-form-group>
      <!-- <b-form-file
        ref="fileInput"
        v-model="file"
        :state="Boolean(file)"
        @change="selectcsvFiletoUpload($event)"
        placeholder="Upload CSV File"
        accept=".csv"
        required
      ></b-form-file> -->
    </b-col>
  </b-row>
</b-form-group>
</b-col>


</b-row>
<b-row>
            <b-col class="mt-4">
              <button class="float-right ml-2 btn btn-md btn-danger" @click.prevent="resetAllFields()">Cancel</button>
            
              <button class="float-right btn-md btn btn-primary" @click.prevent="regularizeEmployee()">Regularize</button>
            </b-col>
          </b-row>
        </div>


  </b-card>
    </b-col>
  </b-row>
  </div>    
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
const axios = require('axios')
export default {
  data() {
    const today = new Date();
  today.setHours(0, 0, 0, 0); // strip time to avoid edge cases

  const twoMonthsAgo = new Date(today);
  twoMonthsAgo.setMonth(today.getMonth() - 1);
      return {
        availableDates: {
      start: twoMonthsAgo,
      end: today
    },
          selectDateForRegularize : null,
          tableEmpList: null,
          fields: [
              { key : 'username', label : 'Emp Name ', sortable: true},
              { key: 'employeeid', label: 'Emp ID', sortable: true },   
              { key: 'contactnumber', label: 'Emp Mob No.' , sortable: true},
              { key: 'premiseid', label: 'Hub Name', sortable: true },
          ],
          totalRows :0,
          vehicleitems : null,
          selected_vehicleno : '',
          isBusy : false,
          
          fieldWH:{ text: 'name', value: 'id' },
          optionsWH:[],
          WHData:[],
          showSelectAll : true,
          loadurl :'',
          LoadDetails:[],
          loadtotalRows: 0,
          loadisBusy : false,
          loaddetailsmodel : false,
          loadfields :[
              { key : 'invoiceno', label : 'Load ID'},
              { key: 'dispatch_date', label: 'Dispatch Date' },
              { key: 'mpscount', label: 'No. Of Boxes' },
              
              { key: 'destinationcompanyname', label: 'Destination Company Name' },
              { key: 'destinationpincode', label: 'Destination Pincode' },
              { key: 'hub_title', label: 'Hub Name' },
             
              { key: 'lastmodifieddate', label: 'Delivery Date' },
          ],
          empDetailsModal:false,
          vehicleDetails:[],
          loader:false,

          employeelist : [],
          selected_employee : '',

          optionsEmployee: null,
          optionsEmployeeID: null,
          valueEmp: null,
          hubName: '',
          noofpages:'',
          pageNum:1,
          showComment: false,
          selectReason: '',
          valueWH: null,
          selected_hub_id: 0,
          slectedName: null,
          selectFilterDate: null,
          employeeDetails: '',
          statusOptions: [
      { label: 'Pending', value: 'pending' },
      { label: 'Approved', value: 'approved' },
      { label: 'Rejected', value: 'rejected' },
    ],
    ShiftOptions:[
    
    ],
    reasonOption:[
      { label: 'Missed Punch Out', value: 'Missed Punch Out' },
      { label: 'Mistakenly Punched Out early', value: 'Mistakenly Punched Out early' },
      { label: 'New Joinee, was not registered in fc clock', value: 'New Joinee, was not registered in fc clock' },
      { label: 'Missed both punch in and punch out', value: 'Missed both punch in and punch out' },
      { label: 'Punched in Late', value: 'Punched in Late' },
      { label: 'Did late break end', value: 'Did late break end' },
      { label: 'Week Off', value: 'Week Off' },
      { label: 'Missed Ot End', value: 'Missed Ot End' },
      { label: 'Missed Ot End', value: 'Missed Ot End' },
      { label: 'Missed Ot Start & Ot End', value: 'Missed Ot Start & Ot End' },
      { label: 'Mistakenly marked Ot end early', value: 'Mistakenly marked Ot end early' },
      { label: 'Missed Ot Start late', value: 'Missed Ot Start late' },
      { label: 'Other Reason', value: 'Other Reason' }
    ],
    form: {
        effectiveStartHour: '',
        effectiveStartMinute: '',
        effectiveEndHour: '',
        effectiveEndMinute: '',
        ovetime_effectiveStartHour: '',
        ovetime_effectiveStartMinute: '',
        ovetime_effectiveEndMinute: '',
        ovetime_effectiveEndHour: '',
        ovetime_effectiveEndMinute: '',
        break_effectiveStartMinute: '',
        break_effectiveStartHour: '',
        break_effectiveEndMinute: '',
        break_effectiveEndHour: '',
        break_effectiveEndMinute: ''
      },
      hourOptions: Array.from({ length: 24 }, (_, i) => {
    const val = i.toString().padStart(2, '0'); // "00" to "23"
    return { value: val, text: val };
  }),
  minuteOptions: Array.from({ length: 60 }, (_, i) => {
    const val = i.toString().padStart(2, '0'); // "00" to "59"
    return { value: val, text: val };
  }),
      selected_weekOff: 'no',
      selected_overTime: 'overtime-no',
      empData:[],
      employeeIDList: [],
      employeeMobileList: [],
      optionsWH:[],
      value_mobile_no: null,
      empId: null,
      valueEmpName: null,
      fc_comment: null,
      selectedShift: null,
      selectedReason: null,
      selected_imagefile:'',
      selectedfile_type :'',
      uploadedphoto :'',
      image_file :'',
      startHourOptions: null, // ✅ must be an array
      endHourOptions: null    // ✅ must be an array
      }
  },

  created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.showWHlist();
      // this.getAllHubShiftList()
  },

  computed: {
filteredOvertimeEndHours() {
  const startHour = parseInt(this.form.effectiveEndHour, 10);
  if (isNaN(startHour)) return this.hourOptions;

  const endHour = (startHour + 9) % 24; // wrap if over 23
  if (endHour > startHour) {
    // Simple range
    return this.hourOptions.filter(h => {
      const val = parseInt(h.value, 10);
      return val >= startHour && val <= endHour;
    });
  } else {
    // Wrap midnight case
    return this.hourOptions.filter(h => {
      const val = parseInt(h.value, 10);
      return val >= startHour || val <= endHour;
    });
  }
},
filteredOvertimeEndMinutes() {
  const startHour = parseInt(this.form.effectiveEndHour, 10);
  const startMinute = parseInt(this.form.effectiveEndMinute, 10);
  const overtimeHour = parseInt(this.form.ovetime_effectiveEndHour, 10);

  if (isNaN(overtimeHour) || isNaN(startHour)) return this.minuteOptions;

  // If same hour, only show minutes >= startMinute
  if (overtimeHour === startHour) {
    return this.minuteOptions.filter(m => parseInt(m.value, 10) >= startMinute);
  }
  return this.minuteOptions;
},
filteredReasonOptions() {
  if (this.selected_weekOff === "no") {
    return this.reasonOption.filter(option => option.value !== "Week Off");
  }
  return this.reasonOption;
}
},
watch: {
selected_weekOff(newVal) {
  if (newVal === "yes") {
    // auto select Week Off
    this.selectedReason = this.reasonOption.find(r => r.value === "Week Off");
  } else if (newVal === "no" && this.selectedReason && this.selectedReason.value === "Week Off") {
    // reset if previously auto-selected
    this.selectedReason = null;
  }
},
selectedShift(newVal) {
  if (!newVal || !newVal.label) return;

  // Extract time range from string "(HH:MM:SS - HH:MM:SS)"
  const match = newVal.label.match(/\(([^)]+)\)/);
  if (!match) return;

  const times = match[1].split(" - ");
  if (times.length !== 2) return;

  // Parse start time
  let [startHour, startMinute] = times[0].split(":").map(Number);
  // Parse end time
  let [endHour, endMinute] = times[1].split(":").map(Number);

  // Store in form
  this.form.effectiveStartHour = String(startHour).padStart(2, "0");
  this.form.effectiveStartMinute = String(startMinute).padStart(2, "0");
  this.form.effectiveEndHour = String(endHour).padStart(2, "0");
  this.form.effectiveEndMinute = String(endMinute).padStart(2, "0");

  // ---- FILTER LOGIC ----
  // Adjust start hour dropdown (special case: if 23 → start from 22)
  let dropdownStartHour = startHour === 23 ? 22 : startHour;
  this.startHourOptions = this.hourOptions.filter(h => {
    const val = parseInt(h.value, 10);
    return val >= dropdownStartHour;
  });

  // Adjust end hour dropdown (special case: end hour 9 → limit till 10)
  let dropdownEndHourLimit = endHour + 1; 
  this.endHourOptions = this.hourOptions.filter(h => {
    const val = parseInt(h.value, 10);
    return val <= dropdownEndHourLimit;
  });
}
},




  methods: {
      showVehicleDetails(value){
          this.vehicleDetails = []
          this.loader=true;
          this.empDetailsModal =! this.empDetailsModal;

          if (this.empDetailsModal) {
          const obj = {
          vehicle_id : value.vehicle_id
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleDetailsForDriverDetails`,obj)
          .then(result=>{
          this.loader=false;
          if(result.body.returnmsg === "Successful"){
          this.vehicleDetails = result.body.returnvalue;
          }
          else{
          this.vehicleDetails = []
          }
          }) 
          }
      },



      

      selectsearchvehicle(value_vehicle) {
          if(value_vehicle==null){
          this.selected_vehicleno="";
          this.DispatchDateList();
          }
      },

      showWHlist:function(){
        
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        
        var csvObj = {
            sysusermasterid:`${userInfo.sysusermasterid}`,
            usertype:`${userInfo.user_type}`
        };
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubList`, csvObj)
          .then(result => {
            
            if (result.body.returnmsg === 'Successful') {
                this.optionsWH=[];
            
                this.WHData  = result.body.returnvalue;
                
                for(let j = 0; j < this.WHData.length; j++) {
                    let WH = {
                    name: this.WHData[j].hub_title + " - " + this.WHData[j].fcclock_hubid,
                    id: this.WHData[j].fcclock_hubid,
                    }
                this.optionsWH.push(WH);
                }
            
            } else {              
                this.WHData  = result.body.returnvalue;
            }
        

        })
        .catch(ex => {
            console.log("error-----", ex);
        });
    },

      clear(){
          this.selectDateForRegularize = null;
          this.selected_vehicleno = '';
          this.valueWH =[];
          this.displaydata();
          this.showWHlist();
          this.DispatchDateList();
      },

      formatDate: function(date) {
          var d = new Date(date),
              month = "" + (d.getMonth() + 1),
              day = "" + d.getDate(),
              year = d.getFullYear();
          if (month.length < 2) month = "0" + month;
          if (day.length < 2) day = "0" + day;
          return [year, month, day].join("-");

      },

      // Ajay Code start here
      showEmplist: function() {

          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);

          // this.employeelist=[];
          const deliveryagentobj = {
              sysusermasterid: `${userInfo.sysusermasterid}`,
              usertype: `${userInfo.user_type}`,
              hub_id: this.valueWH ? this.valueWH: null,
          };
          // console.log("deliveryagentobj", deliveryagentobj);
          // return false;
          this.$http
          .post(
          `${CONSTANTS.MIGRATION_API_URL}/getAllFcClockRegularizationEmpListing`,deliveryagentobj
          
          )
          .then((result) => {
          console.log("YYY", result);
          if (result.body.returnmsg === 'Successful') {
            
                this.empData  = result.body.returnvalue;
                for(let j = 0; j < this.empData.length; j++) {
                    let emp = {
                    name: this.empData[j].username + " - " + this.empData[j].employeeid,
                    id: this.empData[j].username,
                    }

                this.employeelist.push(emp);
                }
            
            } else {              
              this.employeelist = []
              this.valueEmpName = null;
            }
          
          })
          .catch((ex) => {
          console.log("error", ex);
          });
      },

      async showEmpIDlist() {
  try {
    const userdata = localStorage.getItem("userData");
    const userInfo = JSON.parse(userdata);

    const deliveryagentobj = {
      sysusermasterid: `${userInfo.sysusermasterid}`,
      usertype: `${userInfo.user_type}`,
      hub_id: this.valueWH ? this.valueWH : null,
      emp_id: this.valueEmpName ? this.valueEmpName.split(" - ").pop() : null,
    };

    const result = await this.$http.post(
      `${CONSTANTS.MIGRATION_API_URL}/getAllFcClockRegularizationEmpListing`,
      deliveryagentobj
    );

    console.log("YYY", result);

    if (result.body.returnmsg === "Successful") {
      this.employeeIDList =
      result && result.data && result.data.returnvalue.map((item) => item.employeeid) || [];

      this.employeeMobileList =
      result && result.data && result.data.returnvalue
          .map((item) => item.contactnumber)
          .filter((num) => num && num.trim() !== "") || [];

      // ✅ select first one as default
      if (this.employeeIDList.length > 0) {
        this.empId = this.employeeIDList[0];
      }
      if (this.employeeMobileList.length > 0) {
        this.value_mobile_no = this.employeeMobileList[0];
      }
    } else {
      // handle unsuccessful case
      this.employeeIDList = [];
      this.empId = null;
      this.employeeMobileList = [];
      this.value_mobile_no = null;
    }
  } catch (error) {
    console.error("Error fetching employee list:", error);
    this.employeeIDList = [];
    this.employeeMobileList = [];
    this.empId = null;
    this.value_mobile_no = null;
  }
},

getAllHubShiftList: function() {
try {
  var userdata = localStorage.getItem("userData");
var userInfo = JSON.parse(userdata);

// this.employeelist=[];
const deliveryagentobj = {
  sysusermasterid: `${userInfo.sysusermasterid}`,
  usertype: `${userInfo.user_type}`,
  hub_id: this.valueWH ? this.valueWH: null,
};
// console.log("deliveryagentobj", deliveryagentobj);
// return false;
this.$http
.post(
`${CONSTANTS.MIGRATION_API_URL}/getShiftStartTimeAndEndTime`,deliveryagentobj

)
.then((result) => {
console.log("YYY", result);
if (result.body.returnmsg === 'Successful') {

this.ShiftOptions = Array.from(
new Map(
  result.body.returnvalue
    .filter(item => item && item.shiftname && item.shiftstart && item.shiftend)
    .map(item => [
      `${item.shiftname}-${item.shiftstart}-${item.shiftend}`, // unique key
      {
        label: `${item.shiftname} Shift (${item.shiftstart} - ${item.shiftend})`,
        value: `${item.shiftname} Shift`
      }
    ])
).values()
);
   

} else {              
  this.ShiftOptions = []
}

})
.catch((ex) => {
console.log("error", ex);
});
} catch (error) {
  console.log(error, 'errorrrrrrrrrrrrrrr');
  
}
},
showEmpMobilelist: function() {

var userdata = localStorage.getItem("userData");
var userInfo = JSON.parse(userdata);

// this.employeelist=[];
const deliveryagentobj = {
  sysusermasterid: `${userInfo.sysusermasterid}`,
  usertype: `${userInfo.user_type}`,
  emp_mobile_no: this.value_mobile_no ? this.value_mobile_no : null
};
// console.log("deliveryagentobj", deliveryagentobj);
// return false;
this.$http
.post(
`${CONSTANTS.MIGRATION_API_URL}/getAllFcClockRegularizationEmpListing`,deliveryagentobj

)
.then((result) => {
console.log("YYY", result);
if (result.body.returnmsg === 'Successful') {

    this.employeeMobileList = result && result.data && result.data.returnvalue.map(item => item.contactnumber)
   

} else {              
  this.employeeMobileList = []
}

})
.catch((ex) => {
console.log("error", ex);
});
},

      formatDate: function(date) {
          var d = new Date(date),
              month = "" + (d.getMonth() + 1),
              day = "" + d.getDate(),
              year = d.getFullYear();
          if (month.length < 2) month = "0" + month;
          if (day.length < 2) day = "0" + day;
          return [year, month, day].join("-");

      },

      openEmpDetails: function(empdetails) {
          this.empDetailsModal = true;   
          this.employeeDetails = empdetails
      },

      
      
      onChangeHubID (event, name) {
        console.log(event, name)
        if (name == 'selecthub') {
          this.selectedShift = null,
          this.ShiftOptions = []
          this.form.effectiveStartHour = ''
          this.form.effectiveStartMinute = ''
          this.form.effectiveEndHour = ''
          this.form.effectiveEndMinute = ''

              this.employeeIDList = []
              this.value_mobile_no = null
              this.valueEmpName = null;
              this.employeeMobileList = [];
              this.employeelist = [];
              this.tableEmpList = [];
              this.empId = null
          this.getAllHubShiftList(this.valueWH)
          if (event == null) {
            console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaabbbb')
              this.employeeIDList = []
              this.value_mobile_no = null
              this.valueEmpName = null;
              this.employeeMobileList = [];
              this.employeelist = [];
              this.tableEmpList = [];
              this.empId = null
            } else {
              this.showEmplist()
              this.getAllHubShiftList(this.valueWH)
            }
              
              // this.getAllUserListingForFCClockRegularization()

          }
          
      },

      async onChangeEmpName(event, name) {
  console.log(event, name);

  if (name === 'emp_name') {
    if (event === null) {
      console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
      this.empId = null;
      this.employeeIDList = [];
      this.valueEmpName = null;
      this.value_mobile_no = null;
      this.employeeMobileList = [];
    } else {
      // ✅ Await async function call
      await this.showEmpIDlist();
    }

    // ✅ Await async call here too
    await this.getAllUserListingForFCClockRegularization();
  }
},



      onChangeEmPID(event, name) {
        console.log(event, name)
        if (name == 'emp_id') {
            if (name == 'emp_id' && event == null) {
              this.valueEmpName = null
              this.value_mobile_no = null
            } else {
              // this.showEmpMobilelist()
              this.getAllUserListingForFCClockRegularization()
            }
            
          }
      },
      
      onChangeEmpMobile(event, name){
        
        if (name == 'emp_mob_no') {
              this.getAllUserListingForFCClockRegularization()

          }
      },

      getEmpDataAgainstHub:function(hubid){
        
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        
        var csvObj = {
          //   sysusermasterid:`${userInfo.sysusermasterid}`,
          //   usertype:`${userInfo.user_type}`,
            hub_id: hubid ? hubid : ''
        };
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getEmpDataAgainstHub`, csvObj)
          .then(result => {
            
            if (result.body.returnmsg === 'Successful') {
                this.optionsEmployee=[];
            
                this.empData  = result.body.returnvalue;
                
                for(let j = 0; j < this.empData.length; j++) {
                    let WH = {
                    name: this.empData[j].username,
                    id: this.empData[j].employeeid,
                    }
                this.optionsEmployee.push(WH);
                }
                for(let j = 0; j < this.empData.length; j++) {
                    let WH = {
                    name: this.empData[j].employeeid,
                    id: this.empData[j].employeeid,
                    }
                this.optionsEmployeeID.push(WH);
                }
                
            
            } else {              
                this.empData  = result.body.returnvalue;
            }
        

        })
        .catch(ex => {
            console.log("error-----", ex);
        });
      },

      getAllUserListingForFCClockRegularization : function () {
        console.log(this.empId, 'this.empIdthis.empId')
        console.log(this.value_mobile_no, 'this.value_mobile_no')
          try {
              var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          let hub = ''
          if (userInfo.user_type === 2) {
              hub = userInfo.hub_id
          }
          let obj = {
              hub_id:this.valueWH ? this.valueWH : null,
              emp_name: this.valueEmpName ? this.valueEmpName.split(" - ")[0] : null,
              emp_id: this.empId ? this.empId : null,
              emp_mobile_no: this.value_mobile_no ? this.value_mobile_no : null
          };
          this.loadisBusy= true;
          console.log(obj, 'obj')
         // return false;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllFcClockRegularizationListing`, obj)
          .then(result =>{
              this.loadisBusy= false;
              if (result.body.returnmsg === "Successful") {
                  this.tableEmpList = result.body.returnvalue;
              } else {
                  this.tableEmpList = [];
              }
          })
          .catch((ex) => {
              console.log("error", ex);
          });
          } catch (error) {
              console.log(error, 'errorrrrrrrrrrrrrrr') 
          }
      },

      clickCallback (pageNum){
          this.getAllUserListingForFCClockRegularization(pageNum);
      },

      onBlur() {
          console.log('Dropdown closed');
          // You can handle the close event here
      },

      

      convertDateOnly(value) {
          if (!value) return '';
          const date = new Date(value);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
      },
       convertDateTime(dateString) {
  const date = new Date(dateString); // Convert string to Date object

  // Format the date and time
  const options = {
      weekday: 'long', // Full name of the day
      year: 'numeric',
      month: 'long', // Full name of the month
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short' // Include time zone
  };

  return date.toLocaleString('en-IN', options); // Format for India locale
},
timeToMinutes(timeStr) {
const [h, m] = timeStr.split(':').map(Number);
return h * 60 + m;
},
formatDateRegularize(dateStr) {
const d = new Date(dateStr);
const year = d.getFullYear();
const month = String(d.getMonth() + 1).padStart(2, '0');
const day = String(d.getDate()).padStart(2, '0');
return `${year}-${month}-${day}`;
},
regularizeEmployee() {
try {
  // 1️⃣ Validate Date

  var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
  if (!this.selectDateForRegularize) {
    this.$fire({
      text: "Please select a date for regularization",
      type: "error",
      timer: 3000
    });
    return;
  }

  

  

  // 5️⃣ Validate Effective Time
  if (this.selected_weekOff == 'no') {
          // 2️⃣ Validate Shift
          if (!this.selectedShift || !this.selectedShift.value) {
            this.$fire({
              text: "Please select a shift",
              type: "error",
              timer: 3000
            });
            return;
          }
  }

  // 3️⃣ Validate Reason
  if (!this.selectedReason || !this.selectedReason.value) {
    this.$fire({
      text: "Please select a reason",
      type: "error",
      timer: 3000
    });
    return;
  }

  // 4️⃣ Validate Comment
  if (!this.fc_comment || !this.fc_comment.trim()) {
    this.$fire({
      text: "Please enter a comment",
      type: "error",
      timer: 3000
    });
    return;
  }
  

  // 6️⃣ Validate Overtime Time
  

  // 7️⃣ Prepare Payload
  let myTotalRegularize = this.tableEmpList.map(emp => ({
    emp_id: emp && emp.employeeid ? emp.employeeid : null,
emp_name: emp && emp.username ? emp.username : '',
emp_mobile_no: emp && emp.contactnumber ? emp.contactnumber : '',
hub_id: emp && emp.premiseid ? emp.premiseid : null,
regularization_createdAt: this.formatDateRegularize && this.selectDateForRegularize
? this.formatDateRegularize(this.selectDateForRegularize)
: null,
reason: this.selectedReason && this.selectedReason.value ? this.selectedReason.value : '',
week_off: this.selected_weekOff ? this.selected_weekOff : null,
shift: this.selectedShift && this.selectedShift.value ? this.selectedShift.value : null,
effective_start_time: this.form && this.form.effectiveStartHour && this.form.effectiveStartMinute
? `${this.form.effectiveStartHour}:${this.form.effectiveStartMinute}`
: null,
effective_end_time: this.form && this.form.effectiveEndHour && this.form.effectiveEndMinute
? `${this.form.effectiveEndHour}:${this.form.effectiveEndMinute}`
: null,
break_duration: this.form && this.form.break_effectiveStartHour && this.form.break_effectiveEndMinute
? `${this.form.break_effectiveStartHour}:${this.form.break_effectiveEndMinute}`
: null,
overtime_status: this.selected_overTime ? this.selected_overTime : null,
overtime_start_time: this.form && this.form.ovetime_effectiveStartHour && this.form.ovetime_effectiveStartMinute
? `${this.form.ovetime_effectiveStartHour}:${this.form.ovetime_effectiveStartMinute}`
: null,
overtime_end_time: this.form && this.form.ovetime_effectiveEndHour && this.form.ovetime_effectiveEndMinute
? `${this.form.ovetime_effectiveEndHour}:${this.form.ovetime_effectiveEndMinute}`
: null,
comment: this.fc_comment ? this.fc_comment : '',
regularization_file: this.uploadedphoto ? this.uploadedphoto : null,
created_by: (userInfo && userInfo.userfirstname ? userInfo.userfirstname : '') + ' ' +
          (userInfo && userInfo.userlastname ? userInfo.userlastname : ''),
updated_by: (userInfo && userInfo.userfirstname ? userInfo.userfirstname : '') + ' ' +
          (userInfo && userInfo.userlastname ? userInfo.userlastname : ''),

  }));

  const myObj = {
    data: myTotalRegularize,
    userId: this.userId,
    platform: 'web'
  };

  console.log(myObj, 'myObj')
  // return false;
  // 8️⃣ Send API Request
  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/insertFcClockRegularization`, myObj)
    .then(result => {
      this.isBusy = false;
      if (result.body.returnmsg === "Successful") {
        this.items = result.body.returnvalue;
        if (this.items.length > 0) {
          this.$fire({
            text: result.body.returnvalue + " Regularization request is already raised",
            type: "success",
            timer: 3000
          });
        } else {
          this.$fire({
            text: "Regularization request submitted",
            type: "success",
            timer: 3000
          });
        }

        this.selectDateForRegularize = null;
        this.selected_weekOff = 'no';
        this.selectedShift = null;
        this.form.effectiveStartHour = '';
        this.form.effectiveStartMinute = '';
        this.form.effectiveEndHour = '';
        this.form.effectiveEndMinute = '';
        this.form.break_effectiveStartHour = '';
        this.form.break_effectiveEndMinute = '';
        this.form.break_effectiveEndHour = '';
        this.form.ovetime_effectiveStartHour = '';
        this.form.ovetime_effectiveStartMinute = '';
        this.form.ovetime_effectiveEndHour = '';
        this.form.ovetime_effectiveEndMinute = '';
        this.fc_comment = null;
        this.selectedReason = null
        this.valueWH = null
        this.employeelist = []
        this.valueEmpName = null
        this.employeeIDList = []
        this.empId = null
        this.employeeMobileList = [] 
        this.value_mobile_no = null
        this.tableEmpList = [];
        // this.resetAllFields();
        
      } else {
        this.items = [];
        this.totalRows = 0;
      }
    })
    .catch(ex => console.log("error", ex));

} catch (error) {
  console.error("Error in regularizeEmployee:", error);
}
},

timeToMinutes(timeStr) {
const [h, m] = timeStr.split(':').map(Number);
return h * 60 + (m || 0);
},
resetAllFields() {
console.log('resetAllFields called');
    this.valueWH = null;
    this.valueEmpName = null;
    this.empId = null;
    this.value_mobile_no = null;
    this.selectDateForRegularize = null;
    this.selected_weekOff = 'no';
    this.selectedShift = null;
    this.form.effectiveStartHour = '';
    this.form.effectiveStartMinute = '';
    this.form.effectiveEndHour = '';
    this.form.effectiveEndMinute = '';
    this.form.break_effectiveStartHour = '';
    this.form.break_effectiveEndMinute = '';
    this.form.break_effectiveEndHour = '';
    this.form.ovetime_effectiveStartHour = '';
    this.form.ovetime_effectiveStartMinute = '';
    this.form.ovetime_effectiveEndHour = '';
    this.form.ovetime_effectiveEndMinute = '';
    this.fc_comment = null;
    this.selectedReason = null;
    this.tableEmpList = [];
},

selectFile(event){
    
    this.selected_imagefile= event.target.files[0];
    console.log("yyyyy",this.selected_imagefile);
    if (this.selected_imagefile) {
        this.fileUploadMessage = '1 Photo uploaded'; // Update message when a file is uploaded
    } else {
        this.fileUploadMessage = ''; // Reset the message if no file is uploaded
    }
    this.selectedfile_type=this.selected_imagefile.type;
    console.log("yyyyy",this.selectedfile_type);
    this.uploadphoto(this.selected_imagefile);

},

uploadphoto: function () {
const userData = localStorage.getItem('userData');
const userInfo = JSON.parse(userData);

if (!this.selected_imagefile) {
  this.$fire({
    text: "Please select a file before uploading",
    type: "error",
    timer: 3000
  });
  return;
}

let data = new FormData();
data.append('file', this.selected_imagefile);
this.progress = 0;

axios.post(
  `${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,
  data,
  {
    headers: { 'Content-Type': 'multipart/form-data' }, // ✅ fixed plural
    onUploadProgress: (progressEvent) => {
      this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    }
  }
)
.then(response => {
  console.log("response", response);

  if (response.data.result === 'success') {
    this.$fire({
      text: "File Uploaded. Please Submit",
      type: "success",
      timer: 3000
    });
    this.uploadedphoto = response.data.image_url;
    console.log("Uploaded Image URL:", this.uploadedphoto);
  } else {
    this.$fire({
      text: "File Not Uploaded",
      type: "error",
      timer: 3000
    });
  }
})
.catch(e => {
  console.error(e);
  this.$fire({
    text: "An error occurred during upload",
    type: "error",
    timer: 3000
  });
});
}




  },
}
</script>

<style scoped>
.Delivery_Dashboard .table thead tr{
  background: #f0f3f5 !important;
  border: 1px solid #c9b9b9 !important
}
.Delivery_Dashboard .table thead tr:hover {
  background: #f0f3f5 !important;
  border: 1px solid #c9b9b9 !important
}
.Delivery_Dashboard .table thead .bordercalls th{
  border: 0px solid rgb(227, 219, 219) !important;
}
.Delivery_Dashboard .table thead tr th, .Delivery_Dashboard .table thead tr td{
  border: 1px solid rgb(221, 208, 208) !important;
}
.Delivery_Dashboard .table thead .bordercalls .totalload{
  border: 1px solid #c9b9b9 !important
}

.custom-approve-btn {
  background-color: #28a745 !important;  /* Success Green */
  border-color: #28a745 !important;
  color: white !important;
}

.custom-reject-btn {
  background-color: #dc3545 !important;  /* Danger Red */
  border-color: #dc3545 !important;
  color: white !important;
}

/* Hover effect */
.custom-approve-btn:hover {
  background-color: #218838 !important;
}

.custom-reject-btn:hover {
  background-color: #c82333 !important;
}
</style>